<template>
  <b-container fluid>
    <b-row v-if="!islandsLoaded">
      <b-col cols="12">
        <div class="text-center">
          <b-spinner label="Loading..." style="color:#002b36;"></b-spinner>
        </div>
      </b-col>
    </b-row>
    <b-form v-else :class="{'pl-3': lg}" @submit.prevent="submitAddress">
      <b-row>
        <b-col cols="12" xl="6">
          <strong class="text-uppercase font-weight-bold kub-color">{{billingAddress.heading}}</strong>
          <p class="kub-color"><small>{{billingAddress.desc}}</small></p>
          <b-form-group label-class="text-uppercase" :label="billingAddress.title.label">
            <b-form-row>
              <b-col cols="6">
                <b-form-select
                  :options="billingAddress.title.optionsTitle"
                  v-model="billingTitle"
                  @change.native="$v.billingTitle.$model = $event.target.value"
                  :state="validateState('billingTitle')"
                  :aria-describedby="billingAddress.title.inputInvID"
                ></b-form-select>
                <b-form-invalid-feedback :id="billingAddress.title.inputInvID">{{billingAddress.title.inputInvFeedback}}</b-form-invalid-feedback>
              </b-col>
              <b-col cols="6">
                <b-form-checkbox class="float-right" v-model="isCompany" plain>{{billingAddress.company.title}}</b-form-checkbox>
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-form-group v-if="isCompany" label-class="text-uppercase" :label="billingAddress.company.label" :label-for="billingAddress.company.labelFor">
            <b-form-input
              :id="billingAddress.company.labelFor"
              v-model="billingCompany"
              @change.native="$v.billingCompany.$model = $event.target.value"
              :state="validateState('billingCompany')"
              :aria-describedby="billingAddress.company.inputInvID"
            ></b-form-input>
            <b-form-invalid-feedback v-if="!$v.billingCompany.required" :id="billingAddress.company.inputInvID">{{billingAddress.company.inputInvFeedbackEmpty}}</b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!$v.billingCompany.company" :id="billingAddress.company.inputInvID">{{billingAddress.company.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!$v.billingCompany.maxLength" :id="billingAddress.company.inputInvID">{{billingAddress.company.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-row>
            <b-col sm="6">
              <b-form-group label-class="text-uppercase" :label="billingAddress.firstName.label" :label-for="billingAddress.firstName.labelFor">
                <b-form-input
                  :id="billingAddress.firstName.labelFor"
                  v-model="billingFirstName"
                  @change.native="$v.billingFirstName.$model = $event.target.value"
                  :state="validateState('billingFirstName')"
                  :aria-describedby="billingAddress.firstName.inputInvID"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.billingFirstName.required" :id="billingAddress.firstName.inputInvID">{{billingAddress.firstName.inputInvFeedbackEmpty}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.billingFirstName.name" :id="billingAddress.firstName.inputInvID">{{billingAddress.firstName.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.billingFirstName.maxLength" :id="billingAddress.firstName.inputInvID">{{billingAddress.firstName.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group label-class="text-uppercase" :label="billingAddress.lastName.label" :label-for="billingAddress.lastName.labelFor">
                <b-form-input
                  :id="billingAddress.lastName.labelFor"
                  v-model="billingLastName"
                  @change.native="$v.billingLastName.$model = $event.target.value"
                  :state="validateState('billingLastName')"
                  :aria-describedby="billingAddress.lastName.inputInvID"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.billingLastName.required" :id="billingAddress.lastName.inputInvID">{{billingAddress.lastName.inputInvFeedbackEmpty}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.billingLastName.name" :id="billingAddress.lastName.inputInvID">{{billingAddress.lastName.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.billingLastName.maxLength" :id="billingAddress.lastName.inputInvID">{{billingAddress.lastName.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col sm="6">
              <b-form-group label-class="text-uppercase" :label="billingAddress.street.label" :label-for="billingAddress.street.labelFor">
                <b-form-input
                  :id="billingAddress.street.labelFor"
                  v-model="billingStreet"
                  @change.native="$v.billingStreet.$model = $event.target.value"
                  :state="validateState('billingStreet')"
                  :aria-describedby="billingAddress.street.inputInvID"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.billingStreet.required" :id="billingAddress.street.inputInvID">{{billingAddress.street.inputInvFeedbackEmpty}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.billingStreet.street" :id="billingAddress.street.inputInvID">{{billingAddress.street.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.billingStreet.maxLength" :id="billingAddress.street.inputInvID">{{billingAddress.street.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group label-class="text-uppercase" :label="billingAddress.number.label" :label-for="billingAddress.number.labelFor">
                <b-form-input
                  :id="billingAddress.number.labelFor"
                  v-model="billingNumber"
                  @change.native="$v.billingNumber.$model = $event.target.value"
                  :state="validateState('billingNumber')"
                  :aria-describedby="billingAddress.number.inputInvID"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.billingNumber.required" :id="billingAddress.number.inputInvID">{{billingAddress.number.inputInvFeedbackEmpty}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.billingNumber.number" :id="billingAddress.number.inputInvID">{{billingAddress.number.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.billingNumber.maxLength" :id="billingAddress.number.inputInvID">{{billingAddress.number.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-group label-class="text-uppercase" :label="billingAddress.addition.label" :label-for="billingAddress.addition.labelFor">
            <b-form-input
              :id="billingAddress.addition.labelFor"
              v-model="billingAddition"
              @change.native="$v.billingAddition.$model = $event.target.value"
              :state="billingAddition ? validateState('billingAddition') : null"
              :aria-describedby="billingAddress.addition.inputInvID"
            ></b-form-input>
            <b-form-invalid-feedback :id="billingAddress.addition.inputInvID">{{billingAddress.addition.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
            <b-form-invalid-feedback :id="billingAddress.addition.maxLength">{{billingAddress.addition.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-row>
            <b-col sm="6">
              <b-form-group label-class="text-uppercase" :label="billingAddress.zip.label" :label-for="billingAddress.zip.labelFor">
                <b-form-input
                  :id="billingAddress.zip.labelFor"
                  v-model="billingZip"
                  @change.native="$v.billingZip.$model = $event.target.value"
                  :state="validateState('billingZip')"
                  :aria-describedby="billingAddress.zip.inputInvID"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.billingZip.required" :id="billingAddress.zip.inputInvID">{{billingAddress.zip.inputInvFeedbackEmpty}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.billingZip.zip" :id="billingAddress.zip.inputInvID">{{billingAddress.zip.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.billingZip.minLength" :id="billingAddress.zip.inputInvID">{{billingAddress.zip.inputInvFeedbackMinLength}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.billingZip.maxLength" :id="billingAddress.zip.inputInvID">{{billingAddress.zip.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group label-class="text-uppercase" :label="billingAddress.city.label" :label-for="billingAddress.city.labelFor">
                <b-form-input
                  :id="billingAddress.city.labelFor"
                  v-model="billingCity"
                  @change.native="$v.billingCity.$model = $event.target.value"
                  :state="validateState('billingCity')"
                  :aria-describedby="billingAddress.city.inputInvID"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.billingCity.required" :id="billingAddress.city.inputInvID">{{billingAddress.city.inputInvFeedbackEmpty}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.billingCity.city" :id="billingAddress.city.inputInvID">{{billingAddress.city.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.billingCity.maxLength" :id="billingAddress.city.inputInvID">{{billingAddress.city.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-group label-class="text-uppercase" :label="billingAddress.country.label">
            <b-form-select
              :options="billingAddress.country.optionsCountry"
              v-model="billingCountry"
              @change.native="$v.billingCountry.$model = billingCountry"
              :state="validateState('billingCountry')"
              :aria-describedby="billingAddress.country.inputInvID"
            ></b-form-select>
            <b-form-invalid-feedback :id="billingAddress.country.inputInvID">{{billingAddress.country.inputInvFeedback}}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group v-if="isCompany" label-class="text-uppercase" :label="billingAddress.salesTax.label" :label-for="billingAddress.salesTax.labelFor">
            <b-form-input
              :id="billingAddress.salesTax.labelFor"
              v-model="billingSalesTax"
              @change.native="$v.billingSalesTax.$model = $event.target.value; validateVAT()"
              @input="setVAT(null)"
              :state="billingSalesTax ? (validateState('billingSalesTax') && checkVAT) : null"
              :formatter="formatter"
              :aria-describedby="billingAddress.salesTax.inputInvID"
            ></b-form-input>
            <b-form-invalid-feedback :id="billingAddress.salesTax.inputInvID" v-if="$v.billingSalesTax.$dirty && !$v.billingSalesTax.salesTax">{{billingAddress.salesTax.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
            <b-form-invalid-feedback :id="billingAddress.salesTax.maxLength" v-if="$v.billingSalesTax.$dirty && !$v.billingSalesTax.maxLength">{{billingAddress.salesTax.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="checkVAT === false && !$v.billingSalesTax.$invalid">Diese Umsatzsteuer-Identifikationsnummer ist ungültig oder konnte nicht verifiziert werden.</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-class="text-uppercase" :label="billingAddress.phone.label" :label-for="billingAddress.phone.labelFor">
            <b-form-input
              :id="billingAddress.phone.labelFor"
              :placeholder="billingAddress.phone.placeholder"
              v-model="billingPhone"
              @change.native="$v.billingPhone.$model = $event.target.value"
              :state="billingPhone ? validateState('billingPhone') : null"
              :aria-describedby="billingAddress.phone.inputInvID"
            ></b-form-input>
            <b-form-invalid-feedback :id="billingAddress.phone.inputInvID">{{billingAddress.phone.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
            <b-form-invalid-feedback :id="billingAddress.phone.maxLength">{{billingAddress.phone.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-class="text-uppercase" :label="billingAddress.mail.label" :label-for="billingAddress.mail.labelFor">
            <b-form-input
              :id="billingAddress.mail.labelFor"
              v-model="billingMail"
              @change.native="$v.billingMail.$model = $event.target.value"
              :state="validateState('billingMail')"
              :aria-describedby="billingAddress.mail.inputInvID"
            ></b-form-input>
            <b-form-invalid-feedback v-if="!$v.billingMail.required" :id="billingAddress.mail.inputInvID">{{billingAddress.mail.inputInvFeedbackEmpty}}</b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!$v.billingMail.email" :id="billingAddress.mail.inputInvID">{{billingAddress.mail.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
          </b-form-group>
          <div class="pt-2 d-flex justify-content-end"><small>{{billingAddress.mandatoryField}}</small></div>
          <b-form-checkbox class="pt-2" v-model="checkDelivery" plain><p v-html="billingAddress.checkDeliveryAddress"></p></b-form-checkbox>
        </b-col>
        <b-col cols="12" xl="6" v-if="checkDelivery">
          <strong class="text-uppercase font-weight-bold kub-color">{{deliveryAddress.heading}}</strong>
          <p class="kub-color"><small>{{deliveryAddress.desc}}</small></p>
          <b-form-row>
            <b-col sm="6">
              <b-form-group label-class="text-uppercase" :label="deliveryAddress.title.label">
                <b-form-select
                  :options="deliveryAddress.title.optionsTitle"
                  v-model="deliveryTitle"
                  @change.native="$v.deliveryTitle.$model = $event.target.value"
                  :state="validateState('deliveryTitle')"
                  :aria-describedby="deliveryAddress.title.inputInvID"
                ></b-form-select>
                <b-form-invalid-feedback :id="deliveryAddress.title.inputInvID">{{deliveryAddress.title.inputInvFeedback}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-group label-class="text-uppercase" :label="deliveryAddress.company.label" :label-for="deliveryAddress.company.labelFor">
            <b-form-input
              :id="deliveryAddress.company.labelFor"
              v-model="deliveryCompany"
              @change.native="$v.deliveryCompany.$model = $event.target.value"
              :state="deliveryCompany ? validateState('deliveryCompany') : null"
              :aria-describedby="deliveryAddress.company.inputInvID"
            ></b-form-input>
            <b-form-invalid-feedback :id="deliveryAddress.company.inputInvID">{{deliveryAddress.company.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
            <b-form-invalid-feedback :id="deliveryAddress.company.maxLength">{{deliveryAddress.company.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-row>
            <b-col sm="6">
              <b-form-group label-class="text-uppercase" :label="deliveryAddress.firstName.label" :label-for="deliveryAddress.firstName.labelFor">
                <b-form-input
                  :id="deliveryAddress.firstName.labelFor"
                  v-model="deliveryFirstName"
                  @change.native="$v.deliveryFirstName.$model = $event.target.value"
                  :state="validateState('deliveryFirstName')"
                  :aria-describedby="deliveryAddress.firstName.inputInvID"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.deliveryFirstName.required" :id="deliveryAddress.firstName.inputInvID">{{deliveryAddress.firstName.inputInvFeedbackEmpty}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.deliveryFirstName.name" :id="deliveryAddress.firstName.inputInvID">{{deliveryAddress.firstName.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.deliveryFirstName.maxLength" :id="deliveryAddress.firstName.inputInvID">{{deliveryAddress.firstName.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group label-class="text-uppercase" :label="deliveryAddress.lastName.label" :label-for="deliveryAddress.lastName.labelFor">
                <b-form-input
                  :id="deliveryAddress.lastName.labelFor"
                  v-model="deliveryLastName"
                  @change.native="$v.deliveryLastName.$model = $event.target.value"
                  :state="validateState('deliveryLastName')"
                  :aria-describedby="deliveryAddress.lastName.inputInvID"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.deliveryLastName.required" :id="deliveryAddress.lastName.inputInvID">{{deliveryAddress.lastName.inputInvFeedbackEmpty}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.deliveryLastName.name" :id="deliveryAddress.lastName.inputInvID">{{deliveryAddress.lastName.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.deliveryLastName.maxLength" :id="deliveryAddress.lastName.inputInvID">{{deliveryAddress.lastName.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col sm="6">
              <b-form-group label-class="text-uppercase" :label="deliveryAddress.street.label" :label-for="deliveryAddress.street.labelFor">
                <b-form-input
                  :id="deliveryAddress.street.labelFor"
                  v-model="deliveryStreet"
                  @change.native="$v.deliveryStreet.$model = $event.target.value"
                  :state="validateState('deliveryStreet')"
                  :aria-describedby="deliveryAddress.street.inputInvID"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.deliveryStreet.required" :id="deliveryAddress.street.inputInvID">{{deliveryAddress.street.inputInvFeedbackEmpty}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.deliveryStreet.street" :id="deliveryAddress.street.inputInvID">{{deliveryAddress.street.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.deliveryStreet.maxLength" :id="deliveryAddress.street.inputInvID">{{deliveryAddress.street.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group label-class="text-uppercase" :label="deliveryAddress.number.label" :label-for="deliveryAddress.number.labelFor">
                <b-form-input
                  :id="deliveryAddress.number.labelFor"
                  v-model="deliveryNumber"
                  @change.native="$v.deliveryNumber.$model = $event.target.value"
                  :state="validateState('deliveryNumber')"
                  :aria-describedby="deliveryAddress.number.inputInvID"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.deliveryNumber.required" :id="deliveryAddress.number.inputInvID">{{deliveryAddress.number.inputInvFeedbackEmpty}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.deliveryNumber.number" :id="deliveryAddress.number.inputInvID">{{deliveryAddress.number.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.deliveryNumber.maxLength" :id="deliveryAddress.number.inputInvID">{{deliveryAddress.number.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-group label-class="text-uppercase" :label="deliveryAddress.addition.label" :label-for="deliveryAddress.addition.labelFor">
            <b-form-input
              :id="deliveryAddress.addition.labelFor"
              v-model="deliveryAddition"
              @change.native="$v.deliveryAddition.$model = $event.target.value"
              :state="deliveryAddition ? validateState('deliveryAddition') : null"
              :aria-describedby="deliveryAddress.addition.inputInvID"
            ></b-form-input>
            <b-form-invalid-feedback :id="deliveryAddress.addition.inputInvID">{{deliveryAddress.addition.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
            <b-form-invalid-feedback :id="deliveryAddress.addition.maxLength">{{deliveryAddress.addition.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-row>
            <b-col sm="6">
              <b-form-group label-class="text-uppercase" :label="deliveryAddress.zip.label" :label-for="deliveryAddress.zip.labelFor">
                <b-form-input
                  :id="deliveryAddress.zip.labelFor"
                  v-model="deliveryZip"
                  @change.native="$v.deliveryZip.$model = $event.target.value"
                  :state="validateState('deliveryZip')"
                  :aria-describedby="deliveryAddress.zip.inputInvID"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.deliveryZip.required" :id="deliveryAddress.zip.inputInvID">{{deliveryAddress.zip.inputInvFeedbackEmpty}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.deliveryZip.zip" :id="deliveryAddress.zip.inputInvID">{{deliveryAddress.zip.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.deliveryZip.minLength" :id="deliveryAddress.zip.inputInvID">{{deliveryAddress.zip.inputInvFeedbackMinLength}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.deliveryZip.maxLength" :id="deliveryAddress.zip.inputInvID">{{deliveryAddress.zip.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group label-class="text-uppercase" :label="deliveryAddress.city.label" :label-for="deliveryAddress.city.labelFor">
                <b-form-input
                  :id="deliveryAddress.city.labelFor"
                  v-model="deliveryCity"
                  @change.native="$v.deliveryCity.$model = $event.target.value"
                  :state="validateState('deliveryCity')"
                  :aria-describedby="deliveryAddress.city.inputInvID"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!$v.deliveryCity.required" :id="deliveryAddress.city.inputInvID">{{deliveryAddress.city.inputInvFeedbackEmpty}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.deliveryCity.city" :id="deliveryAddress.city.inputInvID">{{deliveryAddress.city.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
                <b-form-invalid-feedback v-if="!$v.deliveryCity.maxLength" :id="deliveryAddress.city.inputInvID">{{deliveryAddress.city.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-group label-class="text-uppercase" :label="deliveryAddress.country.label">
            <b-form-select
              :options="deliveryAddress.country.optionsCountry"
              v-model="deliveryCountry"
              @change.native="$v.deliveryCountry.$model = deliveryCountry"
              :state="validateState('deliveryCountry')"
              :aria-describedby="deliveryAddress.country.inputInvID"
            ></b-form-select>
            <b-form-invalid-feedback :id="deliveryAddress.country.inputInvID">{{deliveryAddress.country.inputInvFeedback}}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-class="text-uppercase" :label="deliveryAddress.phone.label" :label-for="deliveryAddress.phone.labelFor">
            <b-form-input
              :id="deliveryAddress.phone.labelFor"
              :placeholder="deliveryAddress.phone.placeholder"
              v-model="deliveryPhone"
              @change.native="$v.deliveryPhone.$model = $event.target.value"
              :state="deliveryPhone ? validateState('deliveryPhone') : null"
              :aria-describedby="deliveryAddress.phone.inputInvID"
            ></b-form-input>
            <b-form-invalid-feedback :id="deliveryAddress.phone.inputInvID">{{deliveryAddress.phone.inputInvFeedbackSpecialSign}}</b-form-invalid-feedback>
            <b-form-invalid-feedback :id="deliveryAddress.phone.maxLength">{{deliveryAddress.phone.inputInvFeedbackMaxLength}}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="pt-4">
        <b-col class="pr-0" :class="{'pl-0': !lg}" col offset-lg="6" lg="3">
          <b-button href="#" block variant="link" :class="[{'kub-btn': true}, {'text-decoration-none': true}, {'d-flex': true}, {'align-items-center': true}, {'mb-2': xs}]" @click="changeStatusShoppingCart(), collapseCart(), changeView({x: 0, y: 0})">
            <b-icon icon="chevron-left" font-scale="0.95"></b-icon>
            <span class="ml-auto mr-auto">Zurück</span>
          </b-button>
        </b-col>
        <b-col class="pr-0" col lg="3">
          <b-button type="submit" block variant="link" class="kub-btn text-decoration-none d-flex align-items-center" @click="changeView({x: 0, y: 0}), setCalcShipping(islands), validateVAT(), setPaypalDeliveryaddress()">
            <span class="ml-auto mr-auto">Weiter</span>
            <b-icon icon="chevron-right" font-scale="0.95"></b-icon>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import DataSummary from '../../../../data/main/summary/summary'
import DataAddress from '../../../../data/main/summary/address/address'
import DataService from '../../../../services/DataService'
import VATService from '../../../../services/VATService'

import { mapGetters, mapActions } from 'vuex'

import { createHelpers } from 'vuex-map-fields'

import { required, requiredIf, minLength, maxLength, numeric, email, helpers } from 'vuelidate/lib/validators'

const company = helpers.regex('company', /^[\w\u00C0-\u017E\s+/&@.,'!:()-]+$/)
const name = helpers.regex('name', /^[A-Za-z\u00C0-\u017E\s-'.]+$/)
const street = helpers.regex('street', /^[A-Za-z0-9\u00C0-\u017E\s-'.]+$/)
const number = helpers.regex('number', /^[A-Za-z0-9\s-/.]+$/)
const zip = helpers.regex('zip', /^[0-9A-Z\s-]+$/)
const city = helpers.regex('city', /^[A-Za-z\u00C0-\u017E\s-/.()]+$/)
const salesTax = helpers.regex('salesTax', /^[A-Z0-9]+$/)
const phone = helpers.regex('phone', /^[0-9\s-/+]+$/)
const addition = helpers.regex('addition', /^[A-Za-z0-9\u00C0-\u017E\s-./()]+$/)

const { mapFields } = createHelpers({
  getterType: 'getClientField',
  mutationType: 'updateClientField'
})

export default {
  data () {
    return {
      summaryComponents: DataSummary.components,
      billingAddress: DataAddress.billingAddress,
      deliveryAddress: DataAddress.deliveryAddress,
      islands: [],
      islandsLoaded: false,
      currentVATRequestID: 0
    }
  },
  validations: {
    billingTitle: {
      required
    },
    billingCompany: {
      required: requiredIf('isCompany'),
      maxLength: maxLength(100),
      company
    },
    billingFirstName: {
      required,
      maxLength: maxLength(30),
      name
    },
    billingLastName: {
      required,
      maxLength: maxLength(30),
      name
    },
    billingStreet: {
      required,
      maxLength: maxLength(60),
      street
    },
    billingNumber: {
      required,
      maxLength: maxLength(10),
      number
    },
    billingZip: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(5),
      zip
    },
    billingCity: {
      required,
      maxLength: maxLength(60),
      city
    },
    billingCountry: {
      required
    },
    billingSalesTax: {
      maxLength: maxLength(20),
      salesTax
    },
    billingPhone: {
      maxLength: maxLength(20),
      phone
    },
    billingAddition: {
      maxLength: maxLength(60),
      addition
    },
    billingMail: {
      required,
      email
    },
    deliveryTitle: {
      required: requiredIf('checkDelivery')
    },
    deliveryCompany: {
      maxLength: maxLength(100),
      company
    },
    deliveryFirstName: {
      required: requiredIf('checkDelivery'),
      maxLength: maxLength(30),
      name
    },
    deliveryLastName: {
      required: requiredIf('checkDelivery'),
      maxLength: maxLength(30),
      name
    },
    deliveryStreet: {
      required: requiredIf('checkDelivery'),
      maxLength: maxLength(60),
      street
    },
    deliveryNumber: {
      required: requiredIf('checkDelivery'),
      maxLength: maxLength(10),
      number
    },
    deliveryZip: {
      required: requiredIf('checkDelivery'),
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(5),
      zip
    },
    deliveryCity: {
      required: requiredIf('checkDelivery'),
      maxLength: maxLength(60),
      city
    },
    deliveryCountry: {
      required: requiredIf('checkDelivery')
    },
    deliveryPhone: {
      maxLength: maxLength(20),
      phone
    },
    deliveryAddition: {
      maxLength: maxLength(60),
      addition
    }
  },
  methods: {
    ...mapActions([
      'changeStatusShoppingCart',
      'changeStatusAddress',
      'changeView',
      'setCalcShipping',
      'islandsLoadingError',
      'vatLoadingError',
      'setVAT',
      'setVATLoadedDefault',
      'setPaypalDeliveryaddress'
    ]),
    validateState (field) {
      if (!this.$v || !this.$v[field]) {
        return null
      }
      const { $dirty, $error } = this.$v[field]
      return $dirty ? !$error : null
    },
    submitAddress () {
      this.$v.$touch()
      if (!this.$v.$anyError) {
        this.changeStatusAddress()
        this.$root.$emit('bv::toggle::collapse', this.summaryComponents.payment.toggle)
      }
    },
    collapseCart () {
      this.$root.$emit('bv::toggle::collapse', this.summaryComponents.shoppingCart.toggle)
    },
    async validateVAT () {
      if (!this.$v.billingSalesTax.$invalid) {
        this.setVAT(null)
        this.setVATLoadedDefault()
        this.currentVATRequestID++
        const thisRequestID = this.currentVATRequestID
        try {
          if (this.isCompany && this.billingSalesTax) {
            const countryCode = this.billingSalesTax.slice(0, 2)
            const vatNumber = this.billingSalesTax.slice(2)
            if (this.billingCountry.code !== 'DE' && this.billingCountry.code === countryCode && (this.checkDelivery ? this.deliveryCountry.code === this.billingCountry.code : true)) {
              const checkedVAT = await VATService.checkVAT({
                countryCode,
                vatNumber
              })
              if (thisRequestID !== this.currentVATRequestID) {
                return
              }
              this.setVAT(checkedVAT.data.valid)
            } else {
              this.setVAT(null)
            }
          } else {
            this.setVAT(false)
          }
        } catch (err) {
          if (thisRequestID === this.currentVATRequestID) {
            this.vatLoadingError()
            this.setVAT(false)
          }
          console.log(err)
        }
      }
    },
    formatter (value) {
      return value.toUpperCase()
    }
  },
  computed: {
    ...mapGetters([
      'xs',
      'sm',
      'md',
      'lg',
      'shoppingCartComplete',
      'checkDelivery',
      'checkVAT'
    ]),
    ...mapFields({
      billingTitle: 'billingAddress.title',
      billingCompany: 'billingAddress.company',
      billingFirstName: 'billingAddress.firstName',
      billingLastName: 'billingAddress.lastName',
      billingStreet: 'billingAddress.street',
      billingNumber: 'billingAddress.number',
      billingZip: 'billingAddress.zip',
      billingCity: 'billingAddress.city',
      billingCountry: 'billingAddress.country',
      billingSalesTax: 'billingAddress.salesTax',
      billingPhone: 'billingAddress.phone',
      billingAddition: 'billingAddress.addition',
      billingMail: 'billingAddress.mail',
      deliveryTitle: 'deliveryAddress.title',
      deliveryCompany: 'deliveryAddress.company',
      deliveryFirstName: 'deliveryAddress.firstName',
      deliveryLastName: 'deliveryAddress.lastName',
      deliveryStreet: 'deliveryAddress.street',
      deliveryNumber: 'deliveryAddress.number',
      deliveryZip: 'deliveryAddress.zip',
      deliveryCity: 'deliveryAddress.city',
      deliveryCountry: 'deliveryAddress.country',
      deliveryPhone: 'deliveryAddress.phone',
      deliveryAddition: 'deliveryAddress.addition',
      isCompany: 'isCompany',
      checkDelivery: 'checkDelivery'
    })
  },
  watch: {
    shoppingCartComplete: function () {
      this.$v.$reset()
    },
    checkDelivery: function (newValue) {
      this.$v.$reset()
      if (this.isCompany && this.billingSalesTax) {
        this.validateVAT()
      }
    },
    deliveryCountry (newValue) {
      if (this.isCompany && this.billingSalesTax && this.checkDelivery) {
        this.validateVAT()
      }
    },
    billingCountry (newValue) {
      if (this.isCompany && this.billingSalesTax) {
        this.validateVAT()
      }
    },
    isCompany (newValue) {
      if (newValue) {
        if (this.billingSalesTax) {
          this.validateVAT()
        } else {
          this.setVAT(false)
        }
      } else {
        this.setVAT(false)
      }
    }
  },
  async created () {
    try {
      const data = await DataService.getIslands()
      data.forEach(el => {
        this.islands.push(el)
      })
      this.islandsLoaded = true
    } catch (err) {
      this.islandsLoadingError()
      console.log(err)
    }
  }
}
</script>

<style>
</style>
